import { ClickAwayListener } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { FC, useEffect } from 'react';

interface ShowDeniedNotificationProps {
  readonly open: boolean;
  readonly setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

/**
 * Suggest the user enable notifications after they were denied at OS level.
 */
export const ShowDeniedNotification: FC<ShowDeniedNotificationProps> = ({
  open,
  setOpen,
}) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, setOpen]);

  if (!open) return null;

  return (
    <div className="bh-modal">
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <div
          className="st-card"
          data-suit="hearts"
          role="dialog"
          aria-modal="true"
          aria-labelledby="notif-title"
        >
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="st-btn st-btn--ghost st-btn--on-ivory st-icon-btn"
            aria-label="Close"
            style={{ position: 'absolute', top: 8, right: 8 }}
          >
            <CloseIcon />
          </button>
          <div className="bh-stack" style={{ ['--bh-gap' as string]: '14px' }}>
            <p className="st-eyebrow">Notifications are off</p>
            <h2 id="notif-title" className="st-h2">
              Don&apos;t miss your games
            </h2>
            <ul className="bh-checklist">
              <li>
                <span className="bh-checklist__glyph" aria-hidden="true">
                  ✉
                </span>
                <span>
                  <strong>Table invitations</strong> — know when friends deal
                  you in.
                </span>
              </li>
              <li>
                <span
                  className="bh-checklist__glyph"
                  data-red="true"
                  aria-hidden="true"
                >
                  ↺
                </span>
                <span>
                  <strong>Rejoin alerts</strong> — get back to a table that is
                  waiting for you.
                </span>
              </li>
            </ul>
            <p className="st-small st-muted" style={{ margin: 0 }}>
              Open your phone&apos;s <strong>Settings</strong> and allow
              notifications for Bhabi.
            </p>
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="st-btn st-btn--primary st-btn--block"
            >
              Got it
            </button>
          </div>
        </div>
      </ClickAwayListener>
    </div>
  );
};
